var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.hideRoot
    ? _c(
        "div",
        {
          staticClass: "cw-root-content-hint",
        },
        [
          _c("courseware-companion-box", {
            attrs: {
              msgCompanion: _vm.$gettext(
                "In diesem Lernmaterial wird die Startseite ausgeblendet. Dies können Sie in den Einstellungen des Lernmaterials ändern. Wenn Sie die Einstellung beibehalten wollen, legen Sie bitte eine Seite an."
              ),
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "companionActions",
                  fn: function fn() {
                    return [
                      _vm.canEdit
                        ? _c(
                            "button",
                            {
                              staticClass: "button",
                              on: {
                                click: _vm.addPage,
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$gettext("Eine Seite hinzufügen")
                                  ) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3026667891
            ),
          }),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "cw-root-content-wrapper",
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-root-content",
              class: ["cw-root-content-" + _vm.rootLayout],
            },
            [
              _c(
                "div",
                {
                  staticClass: "cw-root-content-img",
                  style: _vm.bgImage,
                },
                [
                  _c(
                    "section",
                    {
                      staticClass: "cw-root-content-description",
                      style: _vm.bgColor,
                    },
                    [
                      _c("div", {
                        staticClass: "cw-root-content-description-img",
                        style: _vm.image,
                        attrs: {
                          src: _vm.imageURL,
                        },
                      }),
                      _vm._v(" "),
                      !_vm.imageIsSet
                        ? [
                            _c("studip-ident-image", {
                              staticClass: "cw-root-content-description-img",
                              attrs: {
                                baseColor: _vm.bgColorHex,
                                pattern: _vm.structuralElement.attributes.title,
                              },
                              model: {
                                value: _vm.identImage,
                                callback: function callback($$v) {
                                  _vm.identImage = $$v
                                },
                                expression: "identImage",
                              },
                            }),
                            _vm._v(" "),
                            _c("studip-ident-image", {
                              staticClass:
                                "cw-root-content-description-background-img",
                              attrs: {
                                width: 4380,
                                height: _vm.withTOC ? 1200 : 1920,
                                baseColor: _vm.bgColorHex,
                                pattern: _vm.structuralElement.attributes.title,
                              },
                              model: {
                                value: _vm.identBgImage,
                                callback: function callback($$v) {
                                  _vm.identBgImage = $$v
                                },
                                expression: "identBgImage",
                              },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "cw-root-content-description-text",
                        },
                        [
                          _c("h1", [
                            _vm._v(
                              _vm._s(_vm.structuralElement.attributes.title)
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.structuralElement.attributes.payload
                                    .description
                                ) +
                                "\n                    "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.withTOC
            ? _c(
                "div",
                {
                  staticClass: "cw-root-content-toc",
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "cw-tiles",
                    },
                    _vm._l(_vm.childElements, function (child) {
                      var _child$relationships,
                        _child$relationships$,
                        _child$relationships$2
                      return _c(
                        "li",
                        {
                          key: child.id,
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: "/structural_element/" + child.id,
                                title: child.attributes.title,
                              },
                            },
                            [
                              _c("courseware-tile", {
                                attrs: {
                                  tag: "div",
                                  color: child.attributes.payload.color,
                                  title: child.attributes.title || "–",
                                  imageUrl: _vm.hasImage(child)
                                    ? (_child$relationships =
                                        child.relationships) === null ||
                                      _child$relationships === void 0
                                      ? void 0
                                      : (_child$relationships$ =
                                          _child$relationships.image) ===
                                          null ||
                                        _child$relationships$ === void 0
                                      ? void 0
                                      : (_child$relationships$2 =
                                          _child$relationships$.meta) ===
                                          null ||
                                        _child$relationships$2 === void 0
                                      ? void 0
                                      : _child$relationships$2["download-url"]
                                    : "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "description",
                                      fn: function fn() {
                                        return [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                child.attributes.payload
                                                  .description
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "footer",
                                      fn: function fn() {
                                        return [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "cw-root-content-toc-tile-footer",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.$gettextInterpolate(
                                                      _vm.$ngettext(
                                                        "%{pages} Seite",
                                                        "%{pages} Seiten",
                                                        _vm.countChildChildren(
                                                          child
                                                        )
                                                      ),
                                                      {
                                                        pages:
                                                          _vm.countChildChildren(
                                                            child
                                                          ),
                                                      }
                                                    )
                                                  ) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }